<template>
    <div class="form-card">
        <ImageUploader
            :url="senderLogoUrl && !isBoringAvatar ? senderLogoUrl : ''"
            :disabled="imageUploadDisabled ?? true"
            location="scorecard_sender_logo"
            :full-image-url-on-upload="true"
            @uploaded="handleSenderImageUpdated"
            @afterRemove="() => handleSenderImageUpdated(null)"
            noShadow
            border-radius="0"
            class="image-uploader-container"
        >
            <div class="sender-settings">
                <SenderInfoLayout
                    :user-id="senderUserId"
                    :user-email="realTimeSenderEmail"
                    :user-full-name="realTimeSenderName"
                    :profile-image-url="senderLogoUrl"
                    :is-auto-generated="isAutoGenerated"
                />
            </div>
        </ImageUploader>
        <div class="inner">
            <oForm ref="formRef" class="sender-info-form">
                <oInput
                    id="sender-name"
                    name="senderName"
                    :placeholder="'Sender Name'"
                    :modelValue="realTimeSenderName"
                    type="text"
                    label="Footer Heading"
                    :required="!isAutoGenerated"
                    :autofocus="autofocusInput"
                    @updated="updateRealTimeSenderName"
                />
                <oInput
                    id="sender-email"
                    name="senderEmail"
                    :placeholder="'Sender Email'"
                    :modelValue="realTimeSenderEmail"
                    type="email"
                    label="Footer Subheading"
                    :required="!isAutoGenerated"
                    @updated="updateRealTimeSenderEmail"
                />
            </oForm>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { oForm, oInput } from '@opteo/components-next'

import { useBoringAvatar } from '@/composition/user/useBoringAvatar'
import ImageUploader from '@/components/global/ImageUploader.vue'
import SenderInfoLayout from '../layouts/SenderInfoLayout.vue'

const props = defineProps<{
    registerSubmitFunction: (submitFunction: () => {}) => void
    senderUserId?: number
    senderName?: string
    senderEmail?: string
    senderLogoUrl?: string | null
    autofocusInput?: boolean
    onSenderLogoUrlUpdate?: (imageUrl: string | null) => void
    imageUploadDisabled?: boolean
    isAutoGenerated: boolean
}>()

const { registerSubmitFunction, onSenderLogoUrlUpdate } = props

const formRef = ref()
onMounted(() => registerSubmitFunction(formRef.value.submit))

const handleSenderImageUpdated = (imageUrl: string | null) => {
    onSenderLogoUrlUpdate && onSenderLogoUrlUpdate(imageUrl)
}

const realTimeSenderName = ref(props.senderName)
const realTimeSenderEmail = ref(props.senderEmail)

const updateRealTimeSenderEmail = (updated: string) => {
    realTimeSenderEmail.value = updated
}
const updateRealTimeSenderName = (updated: string) => {
    realTimeSenderName.value = updated
}

const { currentUserAvatarUrl } = useBoringAvatar()

const isBoringAvatar = computed(() => currentUserAvatarUrl.value === props.senderLogoUrl)
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.form-card {
    @include container;
    @include br-28;
    overflow: hidden;
}

.image-uploader-container {
    min-height: 14rem;
    @include flex-center;
    border-bottom: 1px solid $opteo-light-gray;
}

.inner {
    max-width: 20rem;
    margin: 2rem auto 2.25rem auto;
}
.sender-info-form {
    @include flex;
    flex-direction: column;
    gap: 1.5rem;
}
</style>
